/**
 * WhatsApp Click-to-Chat helper.
 * Sesiune 31 iter 17: cerinta user - integrare WhatsApp +40754243893 pentru contact tehnici.
 *
 * Genereaza link wa.me cu mesaj pre-completat. Functioneaza cu numar WhatsApp personal/business.
 * Click pe butonul de pe oferta deschide WhatsApp Web/App cu mesajul pregatit.
 */

export const WHATSAPP_TECHNICIAN_NUMBER = '40742221414';

/**
 * Construieste URL wa.me cu text pre-completat URL-encoded.
 * @param {string} message - Text mesaj (poate contine \n)
 * @param {string} number - numar fara +, fara 0 fara spatii (default 40754243893)
 * @returns {string} URL https://wa.me/...?text=...
 */
export function buildWhatsAppLink(message, number = WHATSAPP_TECHNICIAN_NUMBER) {
  const encoded = encodeURIComponent(message || '');
  return `https://wa.me/${number}?text=${encoded}`;
}

/**
 * Sablon mesaj standard pentru contact oferta.
 * @param {object} ctx - {nr, total, client}
 * @param {function} t - i18next translate function (cu cheia 'whatsapp_message_template')
 */
export function buildOfferContactMessage({ nr = '-', total = 0, client = '-' }, t) {
  if (typeof t === 'function') {
    return t('whatsapp_message_template', { nr, total: String(total), client });
  }
  return `Buna ziua, am o intrebare despre oferta ${nr} (total ${total} EUR, client ${client}).`;
}
